<div class="container-fluid">
    <div class="row mt-3">
        <div class="col-5">
            <div class="card">
                <div class="card-header">
                    <strong>{{company.name}}</strong> [{{company.id}}]
                    <a href="companies/edit/{{company.id}}" class="btn btn-sm btn-primary float-right"><i
                            class="fa fa-edit"></i> Edit</a>
                </div>
                <div class="card-body">
                    <dl class="row">
                        <dt class="col-sm-3 text-right">Email</dt>
                        <dd class="col-sm-9">
                          <a href="mailto:{{company.firstEmail}}"><i class="fa fa-envelope"></i>{{company.firstEmail}}</a>&nbsp;&nbsp;&nbsp;
                          <a href="mailto:{{company.secondEmail}}"><i class="fa fa-envelope"></i>{{company.secondEmail}}</a>
                        </dd>
                    </dl>
                    <dl class="row">
                      <dt class="col-sm-3 text-right">Phone</dt>
                      <dd class="col-sm-9">
                        <i class="fa fa-phone"></i>{{company.firstPhone}}&nbsp;&nbsp;&nbsp;
                        <i class="fa fa-phone"></i>{{company.secondPhone}}
                      </dd>
                  </dl>
                    <dl class="row">
                        <dt class="col-sm-3 text-right">Registration Date</dt>
                        <dd class="col-sm-9">{{company.createdAt | date:'dd-MM-yyyy HH:mm'}}</dd>
                    </dl>
                    <dl class="row">
                      <dt class="col-sm-3 text-right">VAT</dt>
                      <dd class="col-sm-9">{{company.vat}}</dd>
                    </dl>
                    <dl class="row">
                      <dt class="col-sm-3 text-right">Fiscal Code</dt>
                      <dd class="col-sm-9">{{company.fiscalCode}}</dd>
                    </dl>
                    <dl class="row">
                      <dt class="col-sm-3 text-right">PEC Email</dt>
                      <dd class="col-sm-9">{{company.pecEmail}}</dd>
                    </dl>
                    <dl class="row">
                      <dt class="col-sm-3 text-right">ISD Number</dt>
                      <dd class="col-sm-9">{{company.isdNumber}}</dd>
                    </dl>
                    <dl class="row">
                        <dt class="col-sm-3 text-right">Address</dt>
                        <dd class="col-sm-9">{{company.address}}</dd>
                    </dl>
                    <ng-container *ngIf="company.village;">
                        <dl class="row">
                            <dt class="col-sm-3 text-right">Postal code</dt>
                            <dd class="col-sm-9">{{company.postalCode}}</dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right">Village</dt>
                            <dd class="col-sm-9">{{company.village.name}}</dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right">Province</dt>
                            <dd class="col-sm-9">{{company.village.province.name}}</dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right">Region</dt>
                            <dd class="col-sm-9">{{company.village.province.region.name}}</dd>
                        </dl>
                    </ng-container>
                    <dl class="row">
                      <dt class="col-sm-3 text-right">Country</dt>
                      <dd class="col-sm-9">{{company.country?.name}}</dd>
                    </dl>
                    <dl class="row">
                        <dt class="col-sm-3 text-right">Status</dt>
                        <dd class="col-sm-9">
                            <ng-container *ngIf="company.status === 1; else otherStatus">
                                <h5 style="margin: 0px;"><span class="badge badge-success"
                                        style="font-weight: normal;"><i
                                            class="fa fa-check"></i>{{company.status | companyStatus}}</span></h5>
                            </ng-container>
                            <ng-template #otherStatus>
                                <ng-container *ngIf="company.status === 2; else delete1Template">
                                    <h5 style="margin: 0px;"><span class="badge badge-warning"
                                            style="font-weight: normal;"><i
                                                class="fa fa-exclamation"></i>{{company.status | companyStatus}}</span>
                                    </h5>
                                </ng-container>
                                <ng-template #delete1Template>
                                    <h5 style="margin: 0px;"><span class="badge badge-danger"
                                            style="font-weight: normal;"><i
                                                class="fa fa-minus-circle"></i>{{company.status | companyStatus}}</span>
                                    </h5>
                                </ng-template>
                            </ng-template>
                        </dd>
                    </dl>
                    <dl class="row">
                        <dt class="col-sm-3 text-right">Notes</dt>
                        <dd class="col-sm-9">
                            <div class="card">
                                <div class="card-body">
                                    {{company.notes}}
                                </div>
                            </div>
                        </dd>
                    </dl>
                </div>
                <div class="card-footer" *ngIf="company.clientUsers.length === 0">
                    <button class="btn btn-danger btn-sm float-right" type="button" (click)="hardDeleteCompany()">
                        <i class="fa fa-trash-alt"></i> <br />
                        Force Delete
                    </button>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="card">
                <div class="card-header">
                    <strong><i class="fa fa-calendar-alt"></i> Events</strong>
                </div>
                <div class="card-body" style="max-height: 200px; overflow-y: auto;">
                    <table class="table table-stripped">
                        <thead>
                            <tr>
                                <th>Event Name</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Customer Name</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let client of company.clientUsers">
                                <tr *ngFor="let event of client.events">
                                    <td>{{event.eventName}}</td>
                                    <td>{{event.startDate | date:'dd-MM-yyyy'}}</td>
                                    <td>{{event.endDate | endDate:'DD-MM-YYYY'}}</td>
                                    <td>{{event.clientUser.firstName}} {{event.clientUser.lastName}}</td>
                                    <td><span
                                            [outerHTML]="event.status | eventStatus:event.startDate:event.endDate"></span>
                                    </td>
                                    <td class="text-right">
                                        <a class="btn btn-primary btn-sm" href="events/details/{{event.id}}"><i
                                                class="fa fa-search-plus"></i>
                                                View</a>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card mt-3">
              <div class="card-header">
                  <strong><i class="fa fa-calendar-alt"></i> Offers</strong>
              </div>
              <div class="card-body" style="max-height: 200px; overflow-y: auto;">
                  <table class="table table-stripped">
                      <thead>
                          <tr>
                              <th>Offer Name</th>
                              <th>Start Date</th>
                              <th>End Date</th>
                              <th>Price</th>
                              <th>Status</th>
                              <th></th>
                          </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let offer of company.offers">
                            <td>{{offer.eventName}}</td>
                            <td>{{offer.startDate | date:'dd-MM-yyyy'}}</td>
                            <td>{{offer.endDate | date:'dd-MM-yyyy'}}</td>
                            <td>{{offer.discountedPriceWithVat | currency:'€ '}}</td>
                            <td><span
                                    [outerHTML]="offer.status | eventStatus:offer.startDate:offer.endDate"></span>
                            </td>
                            <td class="text-right">
                                <a class="btn btn-primary btn-sm" href="offers/details/{{offer.id}}"><i
                                        class="fa fa-search-plus"></i>
                                        View</a>
                            </td>
                        </tr>
                      </tbody>
                  </table>
              </div>
          </div>
            <div class="card mt-3">
                <div class="card-header">
                    <strong class="float-left" style="margin-top: 10px;"><i class="fa fa-users"></i> Customers
                        List</strong>
                    <a href="clients/create" class="btn btn-sm btn-primary float-right"><i
                            class="fa fa-user-plus"></i></a>
                </div>
                <div class="card-body">
                    <table class="table table-stripped">
                        <thead>
                            <tr>
                                <th>Customer Name</th>
                                <th>Email</th>
                                <th>Status</th>
                                <th class="text-center">Newsletter</th>
                                <th class="text-center">Administrator</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let client of company.clientUsers">
                                <td>{{client.firstName}} {{client.lastName}}</td>
                                <td>{{client.firstEmail}}</td>
                                <td>{{client.status | clientStatus}}</td>
                                <td class="text-center">
                                    <ng-container *ngIf="client.newsletter; else noNewsletterTemplate">
                                        <i style="color: green;" class="fas fa-check"></i>
                                    </ng-container>
                                    <ng-template #noNewsletterTemplate>
                                        <i style="color: red;" class="fas fa-times"></i>
                                    </ng-template>
                                </td>
                                <td class="text-center">
                                    <ng-container *ngIf="client.administrator; else noAdminTemplate">
                                        <i style="color: green;" class="fas fa-check"></i>
                                    </ng-container>
                                    <ng-template #noAdminTemplate>
                                        <i style="color: red;" class="fas fa-times"></i>
                                    </ng-template>
                                </td>
                                <td class="text-right">
                                    <div class="btn-group navbar p-0" style="display: block">
                                        <a href="clients/edit/{{client.id}}" class="btn btn-secondary btn-sm"><i
                                                class="fa fa-pencil-alt"></i>
                                            Edit</a>
                                        <button type="button"
                                            class="btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width: 30px">
                                            <span class="sr-only">Toggle Dropdown</span>
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="clients/view/{{client.id}}" class="dropdown-item btn btn-sm"><i
                                                    class="fa fa-search-plus"></i>
                                                View</a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card" style="margin-top: 10px;">
                <div class="card-header">
                    <strong class="float-left"><i class="fa fa-users"></i> Printers List</strong>
                </div>
                <div class="card-body">
                    <table class="table table-stripped">
                        <thead>
                            <tr>
                                <th>Printer Name</th>
                                <th>Printer Identifier</th>
                                <th>Printer Status</th>
                                <th class="text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let printer of company.printers">
                                <td>{{printer.name}}</td>
                                <td>{{printer.identifier}}</td>
                                <td>{{printer.status | printerStatus}}</td>
                                <td class="text-right">
                                    <button type="button" style="margin-right:-10px" class="btn btn-sm btn-primary"
                                        (click)="unAssociatePrinterFromCompanyClick(printer)">Remove</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="card">
                        <div class="card-body" style="padding-bottom: 0px;">
                            <div class="form-row align-items-center">
                                <div class="col">
                                    <app-select label="Printer Name" [options]="printerListOptions" [(model)]="selectedPrinter">
                                    </app-select>
                                </div>
                                <div class="col">
                                    <button type="button" class="btn btn-sm btn-default"
                                        (click)="associatePrinterToCompanyClick(selectedPrinter)">Add</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col">
        </div>
    </div>
</div>
<app-confirm-dialog-model #confirmDeleteCompanyDialog (getResult)="getDeleteCompanyDecision($event)"
    modalTitle="Delete Company" modalContent="Do you want to hard delete this Company?" denyText="No" acceptText="Yes">
</app-confirm-dialog-model>
